import type { CreateAccessTokenResponse, ListAccessTokensResponse } from "@scoach/types";

import { api } from "../../lib/http.ts";

export const tokensApi = {
  list: () => api<ListAccessTokensResponse>("/api/access-tokens"),
  create: (label: string, expiresInDays?: number) =>
    api<CreateAccessTokenResponse>("/api/access-tokens", {
      method: "POST",
      body: { label, expiresInDays },
    }),
  revoke: (id: string) => api<{ ok: boolean }>(`/api/access-tokens/${id}`, { method: "DELETE" }),
};
